export const getExternalSignalUrl = (token) => {
  return `${window.location.origin}/external_signal/${token}`;
};
